import { Box, InputLabel, MenuItem, Select, styled, TextField, Typography } from '@mui/material';
import { useState } from 'react';
import { Section } from '../../../components/Section';
import { useApiCall } from '../../../lib/useApiCall';
import { api } from '../../../lib/api';
import { useNavigate } from 'react-router-dom';
import { pathHandler } from '../../../lib/pathHandler';
import { Button } from '../../../components/Button';
import { FormLayout } from '../../../components/FormLayout';
import { ficheRenseignementDtoType } from '../../../lib/api/api';
import { YEARS, yearType } from '../../FicheInscriptionPages/constants';

const ID_DOCUMENTS = ['passport', 'identity_card'] as const;
type idDocumentType = (typeof ID_DOCUMENTS)[number];
const idDocumentMapping: Record<idDocumentType, string> = {
    passport: 'Passeport',
    identity_card: "Carte d'identité",
};

function FicheRenseignement() {
    const [formTextData, setTextFormData] = useState({
        firstName: '',
        lastName: '',
        birthdate: '',
        placeOfBirth: '',
        nationality: '',
        email: '',
        phoneNumber: '',
        address: '',
        zipCode: '',
        town: '',
        parent1FirstName: '',
        parent1LastName: '',
        parent1Address: '',
        parent1Email: '',
        parent1ZipCode: '',
        parent1Town: '',
        parent1PhoneNumber: '',
        parent2FirstName: '',
        parent2LastName: '',
        parent2Address: '',
        parent2ZipCode: '',
        parent2Town: '',
        parent2Email: '',
        parent2PhoneNumber: '',
        idNumber: '',
        idExpirationDate: '',
        visaNumber: '',
    });
    const [selectedPromo, setSelectedPromo] = useState<yearType | undefined>();
    const [selectedIdDocument, setSelectedIdDocument] = useState<idDocumentType | undefined>();

    const navigate = useNavigate();

    const createFicheRenseignementEntryApiCall = useApiCall({
        apiCall: api.createFicheRenseignementEntry,
        onSuccess: () => {
            navigate(pathHandler.getRoutePath('FICHE_RENSEIGNEMENT_SUCCESS'));
        },
    });

    return (
        <FormLayout
            handleSubmit={handleSubmit}
            title="FICHE DE RENSEIGNEMENTS"
            subtitle="2025/2026"
        >
            <Row>
                <InputLabel id="promo-label-id">Promotion * : </InputLabel>

                <Typography variant="h3"> </Typography>
                <Box minWidth={'14vw'}>
                    <Select
                        labelId="promo-label-id"
                        fullWidth
                        required
                        value={selectedPromo}
                        onChange={(e) => setSelectedPromo(e.target.value as yearType)}
                    >
                        {YEARS.map((YEAR) => (
                            <MenuItem value={YEAR}>{YEAR}</MenuItem>
                        ))}
                    </Select>
                </Box>
            </Row>
            <Section variant="h2" title="1. Informations étudiant(e)s">
                <Row>
                    <TextField
                        fullWidth
                        onChange={handleFormChange}
                        required
                        label="Prénom(s)"
                        placeholder="Jeanne, Marie, Sofia"
                        name="firstName"
                        value={formTextData.firstName}
                    />
                    <TextField
                        fullWidth
                        onChange={handleFormChange}
                        required
                        label="Nom"
                        placeholder="Dupont"
                        name="lastName"
                        value={formTextData.lastName}
                    />
                </Row>
                <Row>
                    <TextFieldContainer width="14vw">
                        <TextField
                            style={{ width: '14vw' }}
                            onChange={handleFormChange}
                            required
                            label="Date de naissance"
                            type="date"
                            name="birthdate"
                            placeholder="JJ/MM/AAAA"
                            value={formTextData.birthdate}
                            InputLabelProps={{ shrink: true }}
                        />
                    </TextFieldContainer>
                    <TextField
                        onChange={handleFormChange}
                        required
                        label="Lieu de naissance"
                        fullWidth
                        placeholder="Paris (75)"
                        name="placeOfBirth"
                        value={formTextData.placeOfBirth}
                    />
                </Row>
                <Row>
                    <TextField
                        onChange={handleFormChange}
                        required
                        label="Email"
                        type="email"
                        placeholder="jeanne.dupont@email.com"
                        name="email"
                        fullWidth
                        value={formTextData.email}
                    />
                    <TextFieldContainer width="28vw">
                        <TextField
                            style={{ width: '28vw' }}
                            onChange={handleFormChange}
                            required
                            type="tel"
                            placeholder="06 12 34 56 78"
                            label="Téléphone portable"
                            name="phoneNumber"
                            value={formTextData.phoneNumber}
                        />
                    </TextFieldContainer>
                </Row>
                <Row>
                    <TextField
                        onChange={handleFormChange}
                        required
                        label="Adresse"
                        name="address"
                        value={formTextData.address}
                        fullWidth
                    />
                    <TextFieldContainer width="14vw">
                        <TextField
                            style={{ width: '14vw' }}
                            onChange={handleFormChange}
                            required
                            type="number"
                            label="Code postal"
                            name="zipCode"
                            value={formTextData.zipCode}
                        />
                    </TextFieldContainer>
                    <TextFieldContainer width="14vw">
                        <TextField
                            style={{ width: '14vw' }}
                            onChange={handleFormChange}
                            required
                            label="Ville"
                            name="town"
                            value={formTextData.town}
                        />
                    </TextFieldContainer>
                </Row>
            </Section>
            <Section variant="h2" title="2. Documents">
                <Row>
                    <Box minWidth={'15vw'}>
                        <InputLabel id="id-type-label-id">Type de pièce d'identité * : </InputLabel>
                    </Box>
                    <Box minWidth={'14vw'}>
                        <Select
                            fullWidth
                            labelId="id-type-label-id"
                            placeholder="Type de pièce d'identité *"
                            required
                            value={selectedIdDocument}
                            onChange={(e) =>
                                setSelectedIdDocument(e.target.value as idDocumentType)
                            }
                        >
                            {ID_DOCUMENTS.map((ID_DOCUMENT) => (
                                <MenuItem value={ID_DOCUMENT}>
                                    {idDocumentMapping[ID_DOCUMENT]}
                                </MenuItem>
                            ))}
                        </Select>
                    </Box>
                    <TextFieldContainer width="14vw">
                        <TextField
                            style={{ width: '14vw' }}
                            onChange={handleFormChange}
                            required
                            label="N° de pièce d'identité"
                            name="idNumber"
                            value={formTextData.idNumber}
                        />
                    </TextFieldContainer>
                    <TextField
                        fullWidth
                        type="text"
                        onChange={handleFormChange}
                        required
                        label="Date d'expiration du document"
                        placeholder="02/26"
                        name="idExpirationDate"
                        value={formTextData.idExpirationDate}
                    />
                </Row>
                <Row>
                    <TextField
                        fullWidth
                        type="text"
                        onChange={handleFormChange}
                        label="N° de visa (pour les étudiants étrangers)"
                        name="visaNumber"
                        value={formTextData.visaNumber}
                    />
                </Row>
            </Section>
            <Section title="3. Parents ou tuteurs" variant="h2">
                <Section variant="h3" title="Premier parent ou tuteur">
                    <Row>
                        <TextField
                            fullWidth
                            onChange={handleFormChange}
                            required
                            label="Prénom"
                            name="parent1FirstName"
                            value={formTextData.parent1FirstName}
                        />
                        <TextField
                            fullWidth
                            onChange={handleFormChange}
                            required
                            label="Nom"
                            placeholder="Dupont"
                            name="parent1LastName"
                            value={formTextData.parent1LastName}
                        />
                    </Row>
                    <Row>
                        <TextField
                            onChange={handleFormChange}
                            required
                            label="Adresse"
                            name="parent1Address"
                            value={formTextData.parent1Address}
                            fullWidth
                        />
                        <TextFieldContainer width="14vw">
                            <TextField
                                style={{ width: '14vw' }}
                                onChange={handleFormChange}
                                required
                                type="number"
                                label="Code postal"
                                name="parent1ZipCode"
                                value={formTextData.parent1ZipCode}
                            />
                        </TextFieldContainer>
                        <TextFieldContainer width="14vw">
                            <TextField
                                style={{ width: '14vw' }}
                                onChange={handleFormChange}
                                required
                                label="Ville"
                                name="parent1Town"
                                value={formTextData.parent1Town}
                            />
                        </TextFieldContainer>
                    </Row>
                    <Row>
                        <TextField
                            onChange={handleFormChange}
                            required
                            label="Email"
                            type="email"
                            placeholder="jeanne.dupont@email.com"
                            name="parent1Email"
                            fullWidth
                            value={formTextData.parent1Email}
                        />
                        <TextFieldContainer width="28vw">
                            <TextField
                                style={{ width: '28vw' }}
                                onChange={handleFormChange}
                                required
                                type="tel"
                                placeholder="06 12 34 56 78"
                                label="Téléphone portable"
                                name="parent1PhoneNumber"
                                value={formTextData.parent1PhoneNumber}
                            />
                        </TextFieldContainer>
                    </Row>
                </Section>
                <Section variant="h3" title="Deuxième parent ou tuteur (optionnel)">
                    <Row>
                        <TextField
                            fullWidth
                            onChange={handleFormChange}
                            label="Prénom"
                            name="parent2FirstName"
                            value={formTextData.parent2FirstName}
                        />
                        <TextField
                            fullWidth
                            onChange={handleFormChange}
                            label="Nom"
                            placeholder="Dupont"
                            name="parent2LastName"
                            value={formTextData.parent2LastName}
                        />
                    </Row>
                    <Row>
                        <TextField
                            onChange={handleFormChange}
                            label="Adresse (si différente de celle du parent / tuteur 1)"
                            name="parent2Address"
                            value={formTextData.parent2Address}
                            fullWidth
                        />
                        <TextFieldContainer width="14vw">
                            <TextField
                                style={{ width: '14vw' }}
                                onChange={handleFormChange}
                                label="Code postal"
                                type="number"
                                name="parent2ZipCode"
                                value={formTextData.parent2ZipCode}
                            />
                        </TextFieldContainer>
                        <TextFieldContainer width="14vw">
                            <TextField
                                style={{ width: '14vw' }}
                                onChange={handleFormChange}
                                label="Ville"
                                name="parent2Town"
                                value={formTextData.parent2Town}
                            />
                        </TextFieldContainer>
                    </Row>
                    <Row>
                        <TextField
                            onChange={handleFormChange}
                            label="Email"
                            type="email"
                            name="parent2Email"
                            fullWidth
                            value={formTextData.parent2Email}
                        />
                        <TextFieldContainer width="28vw">
                            <TextField
                                style={{ width: '28vw' }}
                                onChange={handleFormChange}
                                type="tel"
                                placeholder="06 12 34 56 78"
                                label="Téléphone portable"
                                name="parent2PhoneNumber"
                                value={formTextData.parent2PhoneNumber}
                            />
                        </TextFieldContainer>
                    </Row>
                </Section>
            </Section>

            <Button
                loadingText="Envoi de la fiche en cours... Cela peut prendre quelques secondes."
                isLoading={createFicheRenseignementEntryApiCall.isLoading}
                fullWidth
                type="submit"
                variant="contained"
                color="primary"
            >
                ENVOYER
            </Button>
        </FormLayout>
    );

    function computeFicheRenseignementDto(): ficheRenseignementDtoType {
        return {
            selectedPromo: selectedPromo ? selectedPromo.trim() : '',
            firstName: formTextData.firstName,
            lastName: formTextData.lastName,
            birthdate: formTextData.birthdate,
            placeOfBirth: formTextData.placeOfBirth,
            nationality: formTextData.nationality,
            email: formTextData.email,
            phoneNumber: formTextData.phoneNumber,
            address: formTextData.address,
            zipCode: formTextData.zipCode,
            town: formTextData.town,
            parent1FirstName: formTextData.parent1FirstName,
            parent1LastName: formTextData.parent1LastName,
            parent1Address: formTextData.parent1Address,
            parent1Email: formTextData.parent1Email,
            parent1ZipCode: formTextData.parent1ZipCode,
            parent1Town: formTextData.parent1Town,
            parent1PhoneNumber: formTextData.parent1PhoneNumber,
            parent2FirstName: formTextData.parent2FirstName,
            parent2LastName: formTextData.parent2LastName,
            parent2Address: formTextData.parent2Address,
            parent2ZipCode: formTextData.parent2ZipCode,
            parent2Town: formTextData.parent2Town,
            parent2Email: formTextData.parent2Email,
            parent2PhoneNumber: formTextData.parent2PhoneNumber,
            idDocument: selectedIdDocument || '',
            idNumber: formTextData.idNumber,
            idExpirationDate: formTextData.idExpirationDate,
            visaNumber: formTextData.visaNumber,
        };
    }

    function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
        event.preventDefault();

        const ficheRenseignementDto = computeFicheRenseignementDto();
        createFicheRenseignementEntryApiCall.perform(ficheRenseignementDto);
    }

    function handleFormChange(event: React.ChangeEvent<HTMLInputElement>) {
        const { name, value } = event.target;
        setTextFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    }
}

const TextFieldContainer = styled('div')<{ width: string }>(({ theme, width }) => ({
    width,
}));

const Row = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
}));

export { FicheRenseignement };
